<pmv-mask #cpfMask [disabled]="disabled" *ngIf="showCpfMask" [(ngModel)]="value" [label]="label || 'CPF/CNPJ'" mask="999.999.999-99?9999"
  (keydown)="keyPress($event)" [autoClear]="false" (blur)="blurEventCpf($event)" slotChar=" "></pmv-mask>
<pmv-mask #cnpjMask [disabled]="disabled" *ngIf="showCnpjMask" [(ngModel)]="value" [label]="label || 'CPF/CNPJ'" mask="99.999.999/9999-99"
  (keyup)="keyPress($event)" [autoClear]="false" (blur)="blurEventCnpj($event)" slotChar=" "></pmv-mask>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵbf.html